var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.tenderFieldcomponent.component)?_c(_vm.tenderFieldcomponent.component,{key:"tenderField-component",tag:"component",staticClass:"add-automation__card-row",attrs:{"disabled":_vm.disabled,"operators":_vm.operators,"value":_vm.tenderFieldcomponent.value},on:{"update:value":_vm.setValue}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }